import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

import Table from "./Table";

const ListTable = ({
  rows,
  loading = false,
  emptyMessage,
  minWidth,
  tableSx,
  ...tableProps
}) => (
  <Box sx={{ width: "100%", minWidth: 0 }}>
    <Table
      {...tableProps}
      rows={rows}
      size="small"
      tableSx={{
        minWidth,
        "& > tbody > tr": { height: 56 },
        ...tableSx,
      }}
    />
    {!loading && rows.length === 0 && emptyMessage ? (
      <Typography align="center" color="text.secondary" sx={{ py: 6 }}>
        {emptyMessage}
      </Typography>
    ) : null}
  </Box>
);

ListTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
  emptyMessage: PropTypes.node,
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tableSx: PropTypes.object,
};

export default ListTable;
